import { edBelugaMonthly } from './followup/flow';
import { ed, edBeluga, edus } from './Initial/flow';

const EDFlows = { edBeluga, edBelugaMonthly, edus, ed };
export default EDFlows;
